import { Component, ViewEncapsulation } from '@angular/core';
import { Subscription } from 'rxjs';
import { ThemeService } from './service/services/misc/theme/theme.service';
import { SwaService } from './service/services/misc/swa/swa.service';

@Component({
    selector: 'app-root',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
    subscriptions: Subscription[] = [];
    theme$ = this._themeService.themeSubject.asObservable();

    constructor(private _themeService: ThemeService, private swaService: SwaService) {
        this.swaService.init();
    }
}
